import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ 
  message = 'Creating your magical tale...', 
  fullPage = false,
  overlay = false
}) => {
  // Create classnames based on props
  const containerClass = `loading-spinner-container ${fullPage ? 'full-page' : ''} ${overlay ? 'overlay' : ''}`;

  return (
    <div className={containerClass}>
      <div className="spinner"></div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
